__turbopack_context__.v({
  "figure": "HowItWorks-module__qt0LDG__figure",
  "section": "HowItWorks-module__qt0LDG__section",
  "step": "HowItWorks-module__qt0LDG__step",
  "stepBody": "HowItWorks-module__qt0LDG__stepBody",
  "stepTitle": "HowItWorks-module__qt0LDG__stepTitle",
  "steps": "HowItWorks-module__qt0LDG__steps",
});
